module.exports = __webpack_public_path__ + "static/img/kxd.1e68ecc.png";


//////////////////
// WEBPACK FOOTER
// ./lib/imgs/shops/kxd.png
// module id = w6an
// module chunks = 1